module.exports = __webpack_public_path__ + "static/img/photo_2023-10-26_15-28-45.be9d0a6f.jpg";